export const GET_CIGARETTES = "@habits/getCigarettes";